import React, { useEffect, useRef } from 'react'

import { useAppState } from '../appState'
import axios from '../axios'
import { clearCjPidsRegistry, setCjPidsRegistry } from '../cjPidRegistry'
import { baseURL, ENDPOINTS } from '../constants'
import { normalizeUserCjPidsResponse } from '../utils/normalizeUserCjPidsResponse'

/**
 * Loads Commission Junction PID map from the backend when the user is authenticated
 * and mirrors it into context plus `cjPidRegistry` for `generateTrackingLink`.
 */
const UserCjPidsSync = () => {
  const [{ auth, userId }, dispatch] = useAppState()
  const requestIdRef = useRef(0)

  useEffect(() => {
    if (!auth || userId == null || userId === '') {
      clearCjPidsRegistry()
      dispatch({
        type: 'RESET_CJ_USER_PIDS',
      })
      return
    }

    const id = ++requestIdRef.current
    let cancelled = false

    const run = async () => {
      clearCjPidsRegistry()
      dispatch({ type: 'SET_CJ_USER_PIDS_LOADING' })
      try {
        const { data } = await axios.get(
          `${baseURL}${ENDPOINTS.userCjPids}?page=0&pageSize=100`
        )
        if (cancelled || id !== requestIdRef.current) return

        const { byUserId, bySegment } = normalizeUserCjPidsResponse(data)
        setCjPidsRegistry({ byUserId, bySegment })
        dispatch({
          type: 'SET_CJ_USER_PIDS',
          cjUserPidsByUserId: byUserId,
          cjPidsBySegment: bySegment,
        })
      } catch {
        if (cancelled || id !== requestIdRef.current) return
        clearCjPidsRegistry()
        dispatch({ type: 'SET_CJ_USER_PIDS_ERROR' })
      }
    }

    run()

    return () => {
      cancelled = true
    }
  }, [auth, userId, dispatch])

  return null
}

export default UserCjPidsSync
